import { createFileRoute } from '@tanstack/react-router';
import { StaffPage, merchantStaffQueryOptions } from '@/features/staff';

export const Route = createFileRoute('/_authed/staff/')({
  loader: ({ cause, context }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(merchantStaffQueryOptions());
  },
  component: StaffIndexRouteComponent,
});

function StaffIndexRouteComponent() {
  return <StaffPage />;
}
